// main tools
import ImageUI from 'next/legacy/image'

// utils
import { blurDataURL, sizeImage } from './utils'

// types
import type { ImageProps as ImageUIProps } from 'next/legacy/image'
import type { FC, MouseEventHandler } from 'react'

export interface ImageProps extends ImageUIProps {
  circle?: boolean
  sizeWidth?: keyof typeof sizeImage
  sizeHeight?: keyof typeof sizeImage
  onClick?: MouseEventHandler<HTMLElement>
}

export const Image: FC<ImageProps> = ({
  onClick,
  className = '',
  circle = false,
  sizeWidth = 'xs',
  sizeHeight = 'xs',
  objectFit = 'cover',
  ...props
}) => {
  const width = props.layout !== 'fill' ? sizeImage[sizeWidth] : undefined
  const height = props.layout !== 'fill' ? sizeImage[sizeHeight] : undefined

  return (
    <ImageUI
      {...props}
      width={width}
      height={height}
      onClick={onClick}
      placeholder='blur'
      objectFit={objectFit}
      blurDataURL={blurDataURL}
      role={onClick ? 'button' : undefined}
      className={`${className} ${circle && 'rounded-circle'}`}
    />
  )
}
